// extracted by mini-css-extract-plugin
export var gif = "_ic-0";